const urlValidationRegex = new RegExp("[(http(s)?):\\/\\/(www\\.)?a-zA-Z0-9@:%._\\+~#=]{2,256}\\.[a-z]{2,6}\\b([-a-zA-Z0-9@:%_\\+.~#?&//=]*)");

export const FlagValidUrl = (values: string[]) => {
    for (let i = 0; i < values.length; i++) {
        if (!urlValidationRegex.test(values[i])) {
            return false;
        }
    }
    return true;
};